module.exports = {
  template: require('./gateways-list-container.pug')()
  controller: require('./gateways-list-container.ctrl')
}
